import SetRoute from '../services/setRoute';

const fetchUncheckedImpactingPoliciesCount = (
    fetch,
    params = '',
) => ({
    payload: {
        dataset: 'unchecked_impacting_policy_count',
        action: 'get',
        route: SetRoute + `/api/v1/impacting_policies/unchecked_count${params}`,
        data: {},
    },
    fetch,
});

export {
    fetchUncheckedImpactingPoliciesCount,
};

export default fetchUncheckedImpactingPoliciesCount;
